<template>
  <div>
    TEST
    <v-container v-if="!loading" grid-list-md fluid class="ma-0 pa-1">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12>
          <div v-if="(companies.length > 1 || branches.length > 1) && !demoMode" class="content-header-minimum barometers clear">
            <div class="clear">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md3 xs12 v-if="companies.length > 1">
                    <v-select
                      :items="filteredCompanies"
                      :item-color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      item-text="name"
                      item-value="id"
                      v-on:input="loadActiveCompData()"
                      v-model="activeComp"
                      no-data-text="Geen aansluiting gevonden."
                      label="Selecteer aansluiting"
                      outlined
                      hide-details
                      dense>
                      <template v-slot:prepend-item >
                        <v-list-item class="ma-0">
                          <v-list-item-content  class="pt-0" >
                            <v-text-field
                              :color="companyPrimaryColor"
                              placeholder="Zoeken"
                              prepend-inner-icon="search"
                              clearable
                              background-color="background"
                              outlined
                              v-model="searchCompanies"
                              hide-details
                              dense
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} aansluitingen</div>
                        <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex md3 xs12>

                    <v-select
                      v-if="branches.length > 1"
                      :items="branches"
                      v-on:input="selectBranch()"
                      :item-color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      item-text="branchName"
                      item-value="id"
                      v-model="activeBranch"
                      label="Selecteer locatie"
                      outlined
                      hide-details
                      dense
                    >
                    </v-select>
                  </v-flex>
                  <v-flex md3 xs12></v-flex>
                  <v-flex md3 xs12 v-if="userRole == 'superadmin' && !demoMode">
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </div>

          <v-card outlined v-if="!loading" class="mt-4">
            <v-container grid-list-md fluid class="ma-0 pa-1">
              <v-layout row wrap class="ma-0 pa-0">
                <v-flex md4 xs12>
                  <v-btn :color="weekSelected.color" depressed :loading="weekSelected.loading" @click="filterConversionWeek()" style="margin: 0; height: 48px;" block large><span :style="{color: weekSelected.textColor}">Deze week</span></v-btn>
                </v-flex>
                <v-flex md4 xs12>
                  <v-btn :color="monthSelected.color" depressed :loading="monthSelected.loading" @click="filterConversionMonth()" style="margin: 0; height: 48px;" block large><span :style="{color: monthSelected.textColor}">Deze maand</span></v-btn>
                </v-flex>
                <v-flex md4 xs12>
                  <v-btn :color="periodSelected.color" depressed :loading="periodSelected.loading" @click="filterConversionPeriod()" style="margin: 0; height: 48px;" block large><span :style="{color: periodSelected.textColor}">Selecteer maand</span></v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-if="filterPeriod" row wrap class="ma-0 pa-0">
                <v-flex md3 xs12>
                  <v-select
                    single-line
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    :items="activeYears"
                    label="Selecteer jaar"
                    hide-details
                    outlined
                    background-color="background"
                    v-model="selectedPeriodYear"      
                  ></v-select>
                </v-flex>
                <v-flex md6 xs12>
                  <v-select
                    single-line
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    :items="months"
                    item-text="name"
                    item-value="id"
                    item-disabled="disabled"
                    label="Selecteer maand"
                    hide-details
                    v-model="selectedPeriodMonth"
                    background-color="background"
                    outlined 
                  ></v-select>
                </v-flex>
                <v-flex md3 xs12>
                  <v-btn @click="loadCustomPeriodFilter(selectedPeriodMonth, selectedPeriodYear, 'filter')" :disabled="filterButtonDisabled" :depressed="filterButtonDisabled" :color="companySecondaryColor" style="margin: 0; height: 55px;" large block><span style="color:#fff;">Filter</span></v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="!dataLoading" grid-list-md fluid class="ma-0 pa-1">
     


      <div class="flow-chart-wrapper"  :style="{height: size.height, width : size.width }">
          <workflow-chart 
          :style="size"
          :transitions="callTransitions"
          :states="callExtentions" 
          :orientation="'vertical'"
          @size-change="sizeChanged"
          :stateSemantics="stateSemantics" 
          />
      </div>

    </v-container>



    <div v-if="dataLoading && !loading" class="fancy-loader"></div>

    <div class="no-data" v-if="!dataLoading && !loading && noDataLogs && noDataPopup">
      <div class="medical-image" :class="randomMedical"></div>
      <p>Geen data gevonden.</p>
    </div>


  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "../firebase/init";
import axios from "axios";
import moment from "moment";
import slugify from "slugify";
import momenttz from "moment-timezone";
import _ from "lodash";
import WorkflowChart from 'vue-workflow-chart';


export default {
  name: "Flow",
  components: {
    WorkflowChart,
  },

  data: () => ({
    callTransitions: [],
    callExtentions: [],
    size: { width: '0px', height: '0px' },
    loading: true,
    dataLoading: true,

    filterToday: true,
    filterWeek: false,
    filterMonth: false,
    filterPeriod: false,
    selectedPeriodDay: "01",
    selectedPeriodYear: moment().year(),
    selectedPeriodMonth: Number(moment().format("M")),

    activeComp: null,
    activeCompData: {},
    activeCompDataOriginal: null,

    companies: [],
    branches: [],
    activeBranch: [],
    extentions: [],
    selectedExtentions: [],
    
    searchCompanies: "",
    noDataLogs: false,
    noDataPopup: false,
    calls: [],
    callTypes: new Object(),
    callDataPeriodType: 'day',
    callDataPeriodStart: null,
    callDataPeriodEnd: null,
    callPhones: [],
    callQueues: [],
    internalCalls: null,
    queue: null,
    outgoingCalls: null,
    incomingCalls: null,
    callSubjects: [],
    callSubjectsLoading: true,

    compStartYear: null,
    compStartMonth: null,


    latestCall: null,
    queueCalls: [],
    urgencyCalls: [],
    callPhonesUrgency: [],
    unansweredQueueCalls: [],
    unansweredQueueCallsData: {
      success: 0,
      failed:0
    },
    stateSemantics: [{
      "classname": "terminated",
      "id": "terminated",
    }],
    chartSeries: [{
      name: 'Aantal gesprekken',
      data: []
    }],
    chartWidth: "100%",
    chartHeight: 'auto',

    popupChartLabels: {},
  }),

  created() {
    this.loadUserComp()
    // this.calculateChartWidth();
    // window.addEventListener("resize", this.calculateChartWidth);
  },

  mounted() {},

  methods: {

    sizeChanged(size) {
      console.log("sizeChanged")
        this.size = {
          width: "800px",
            // width: `${size.width}px`,
            height: `${size.height}px`,
        };
    },


    loadUserComp() {     
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .where("deleted.deleted", "==", false)
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){ 
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            +2
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            if(doc.data().created){
              this.compStartYear = moment.unix(doc.data().created.seconds).format("YYYY")
              this.compStartMonth = moment.unix(doc.data().created.seconds).format("M")
            } else {
              this.compStartYear = moment().year()
              this.compStartMonth = moment().month()
            }
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        })
        .then(() => {
          this.loadBranches();
          this.loadExtentions();  
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          console.error("Error getting company data:", error);
        });
    },

    selectBranch(){
      window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.activeBranch)
      this.loadExtentions();
    },

    loadExtentions() {
      this.extentions = [];
      this.selectedExtentions = [];  

      db.collection("extentions")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.extentions = [];
          snap.forEach(doc => {
            let extention = doc.data();
            extention.id = doc.id;
            
            if(extention.branch == this.activeBranch){
              this.extentions.push(extention);
              this.selectedExtentions.push(extention);
            }
             
          });
        })
        .then(() => {
          this.extentions = _.orderBy(this.extentions, ['number'], ['asc']);
          this.selectedExtentions = _.orderBy(this.selectedExtentions, ['number'], ['asc']);
          this.filterConversionWeek()
        });
    },

    loadBranches() {
      // Load branches
      this.branches = [];

      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            
            if(this.userRole == 'superadmin'){
              this.branches.push(branchCollection);
            }
            else{
              let branchIndex = this.userBranches.indexOf(branchCollection.id);
              if(branchCollection.id && branchIndex >= 0){
                this.branches.push(branchCollection);
              }
            }  
          });
        })
        .then(()=>{
          let selectedBranch = window.localStorage.getItem(`selectedBranch${this.activeComp}`)

          // Check if a selected branch is set in the Local Storage
          if(selectedBranch){ 
            // Check if the selected branch is an option
            let selectedBranchIndex = _.findIndex(this.branches, { 'id': selectedBranch })

            // Selected branch is an option, set activeComp
            if(selectedBranchIndex >= 0){
              this.activeBranch = this.branches[selectedBranchIndex].id;
            } 
            // Selected branch is no option, set first branch as activeComp 
            else{
              this.activeBranch = this.branches[0].id;
              window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.branches[0].id)
            }
          }
          // No selected branch is set 
          else {
            this.activeBranch = this.branches[0].id;
            window.localStorage.setItem(`selectedBranch${this.activeComp}`, this.branches[0].id)
          }

          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.error = true;
          console.error("Error getting branches:", error);
        });
    },

    filterConversionToday(){
      this.filterToday = true;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().startOf('day').format("YYYY-MM-DD");
      let lastDate = moment().endOf('day').add(1, 'day').format("YYYY-MM-DD");
  
      // this.loadCallDataDate(firstDate, lastDate, 'day');
      this.queryCallLogs(firstDate, lastDate, 'day');
    },

    filterConversionWeek(){
      this.filterToday = false;
      this.filterWeek = true;
      this.filterMonth = false;
      this.filterPeriod = false;
      let firstDate = moment().weekday(0).format("YYYY-MM-DD");
      let lastDate = moment().weekday(7).add(1, 'day').format("YYYY-MM-DD");
  
      //this.loadCallDataDate(firstDate, lastDate, 'week');
      this.queryCallLogs(firstDate, lastDate, 'week');
    },

    filterConversionMonth(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = true;
      this.filterPeriod = false;
      let firstDate = moment().startOf('month').format("YYYY-MM-DD");
      let lastDate = moment().endOf('month').add(1, 'days').format("YYYY-MM-DD");

      //this.loadCallDataDate(firstDate, lastDate, 'month');
      this.queryCallLogs(firstDate, lastDate, 'month');
    },

    filterConversionPeriod(){
      this.filterToday = false;
      this.filterWeek = false;
      this.filterMonth = false;
      this.filterPeriod = true;
    },


    loadCustomPeriodFilter(start, end, filter){
      if(filter == 'url'){
        //this.loadCallDataDate(start, end, 'month')
        this.queryCallLogs(start, end, 'month')

      } else {
        this.selectedPeriodDay = '01'
        let selectedDate = this.selectedPeriodYear+"-"+this.selectedPeriodMonth+"-01"
        let firstDate = moment(selectedDate).startOf('month').format("YYYY-MM-DD");
        let lastDate = moment(selectedDate).endOf('month').add(1, 'days').format("YYYY-MM-DD");

        //this.loadCallDataDate(firstDate, lastDate, 'month');
        this.queryCallLogs(firstDate, lastDate, 'month');
      }
    },
    
    queryCallLogs(firstDate, lastDate, type) {
      this.latestCall = null;
      this.dataLoading = true;
      this.calls = [];
      
      this.callSubjects = [];
      this.callSubjectsLoading = true;

      // Load Call Logs
      firebase.auth().currentUser.getIdToken(true)
        .then(idToken=> {
          let data = JSON.stringify({
            token: idToken,
            companyId: this.activeCompData.id,
            type: "logs",
            compType: this.activeCompData.type,
            start: firstDate,
            end: lastDate
          })
          var config = {
            method: 'post',
            url: 'https://query.hogans.nl/getCallData',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          axios(config)
          .then(response=> {
            this.calls = response.data;
            if(this.calls.length > 0){
              const zone = 'Europe/Amsterdam';
              let latestDate = moment(this.calls[this.calls.length - 1].timestamp.value)
              this.latestCall = moment(latestDate, zone).utc().format("YYYY-MM-DD HH:mm");
            }
            this.checkExtentions();
          })
          .catch(error=> {
            console.error("Error getting data from bigquery: ", error);
            console.error(error.response.data);
          });

        })
      .catch(error=> {
        console.error("Error getting ID Token", error);
      });
      
     
      // Load Call Logs
      firebase.auth().currentUser.getIdToken(true)
        .then(idToken=> {
          let data = JSON.stringify({
            token: idToken,
            companyId: this.activeCompData.id,
            type: "popup",
            compType: this.activeCompData.type,
            start: firstDate,
            end: lastDate
          })
          var config = {
            method: 'post',
            url: 'https://query.hogans.nl/getCallData',
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
          };
          axios(config)
          .then(response=> {
            this.callSubjects = response.data;
            this.filterCallSubjects();
          })
          .catch(error=> {
            console.error(error.response.data);
          });

        })
      .catch(error=> {
        console.error("Error getting ID Token", error);
      });
    },

    checkExtentions(){
      this.selectedExtentions = _.orderBy(this.selectedExtentions, ['number'], ['asc']);
      this.callPhones = []
      this.callQueues = [];
      this.callPhonesUrgency = [];

      this.selectedExtentions.forEach(extention=>{
        if(extention.type == 'queue'){
          this.callQueues.push(extention)
        }
        else if(extention.type == 'landLine' || extention.type == 'mobilePhone'){
          this.callPhones.push(extention)
        }
        else if(extention.type == 'urgency'){
          this.callPhonesUrgency.push(extention)
        }
      })
      this.filterCallFlow();
    },

    async checkIncomingCall(type, data){
      let valid = false;
      let counter = 0;

      await new Promise((resolve)=>{
        if(type == 'queue'){
          if(this.callQueues.length > 0){
            this.callQueues.forEach(queue=>{
              if(data.includes("("+queue.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callQueues.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'phone'){
          if(this.callPhones.length > 0){
            this.callPhones.forEach(phone=>{
              if(data.includes("("+phone.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callPhones.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
        if(type == 'urgency'){
          if(this.callPhonesUrgency.length > 0){
            this.callPhonesUrgency.forEach(phone=>{
              if(data.includes("("+phone.number+")")){
                valid = true;
              }
              counter++
              if(counter == this.callPhonesUrgency.length){
                resolve();
              }
            })
          }
          else{
            resolve();
          }
        }
      })
      return valid;
    },


   async filterCallFlow(){
      this.callExtentions = []
      this.callTransitions = []
      let extentions = {};
      let transitions = {};

      this.calls.forEach(call=>{
        let destination =  call.destination.match(/(?<=\().+?(?=\))/g);
        let extractedExtensions = call.reason.match(/(?<=\().+?(?=\))/g) ? call.reason.match(/(?<=\().+?(?=\))/g) : new Array();

        let validPhoneCall = true;

        //Check if phonenumber is ok and if 

        if(call.destination.includes("*")){
          validPhoneCall = false;
        }
        if(call.destination.includes("+")){
          console.log("GEvonden: ", destination)
        }


        if(validPhoneCall && destination && destination.length > 0){
          let extensions = { start: destination[0], end: null };      
          if(extractedExtensions && extractedExtensions.length > 0){
            if((call.reason.toLowerCase()).includes("terminated")){
              extensions.end = 'terminated';
            }
            else{
              extensions.end = extractedExtensions[extractedExtensions.length - 1];
            }

            if(extensions.end.includes("+")){
              validPhoneCall = false;
            }

            if(validPhoneCall){
              let transition = extensions.start + extensions.end;

              if(!extentions[extensions.start]){
                extentions[extensions.start] = {
                  id: extensions.start,
                  label: extensions.start,
                }
              }
              if(!extentions[extensions.end]){
                extentions[extensions.end] = {
                  id: extensions.end,
                  label: extensions.end,
                }
              }
        
              if(transitions[transition]){
                transitions[transition].label++
              }
              else{
                transitions[transition] = {
                  id: transition,
                  name: `Van ${extensions.start} naar ${extensions.end}`,
                  label: 1,
                  target: extensions.end,
                  source: extensions.start
                }
              }
            }
            
          }
          
          // if(extensions.end != extensions.start){
          //   if(calls[call.callerId]){
          //     calls[call.callerId].extensions.push(extensions);
          //     if(call.totals){
          //       calls[call.callerId].total = call.totals;
          //     }
          //   }
          //   else{
          //     calls[call.callerId] = { 
          //       extensions: [extensions],
          //       total: call.totals ? call.totals : null,
          //     }
          //   }
          // }
        }
      })

      // for (const [key, value] of Object.entries(calls)) {
      //   let extentionsNumber = new Array(value.extensions.length);
      //   let sortedExtensions = new Array();
      //   let start = null;
      //   let counter = 0;
      //     for (let index = 0; index < extentionsNumber.length; index++) {
      //       await this.getNextExtentionNumber(value.extensions, start).then((item)=>{
      //         sortedExtensions.push(item)
      //         start = item.end;
      //         counter++
      //         console.log("counter: ", counter, "-", extentionsNumber.length )
      //         if(counter == extentionsNumber.length){
      //           console.log("value.sortedExtentions set: ", index)
      //           value.sortedExtentions = sortedExtensions;
      //         }
      //       })
      //     }
      // }

      

      this.callExtentions = Object.values(extentions);
      this.callTransitions = Object.values(transitions);

      //Find labels
      this.callExtentions.forEach(extention=>{
        if(extention.label == 'terminated'){
          extention.label = "Gesprek beëindigd"
        }
        else{
          let extentionData = _.find(this.extentions, { 'number': String(extention.id) });
          extention.label = extentionData ? extentionData.name : extention.label;
        }
      })

      this.callTransitions.forEach(transition=>{
        transition.label = String(transition.label)
      })
      this.dataLoading = false;
    },

    async getNextExtentionNumber(items, start){
      let foundItem = null;
      await new Promise((resolve)=>{
        let counter = 0;
        for (let index = 0; index < items.length; index++) {
          if(!start){
            if(items[index].start == "100" || items[index].start == "101"){
              foundItem = items[index];
            }
          }
          else if(start){
            if(items[index].start == start){
              foundItem = items[index];
            }
          }
          counter++
          if(counter == items.length){
            foundItem = foundItem ? foundItem : items[0];
            resolve()
          }
        }
      })
      return foundItem;
    },

  },

  computed: {
    selectAllExtentions () {
      return this.selectedExtentions.length === this.extentions.length
    },
    selectSomeExtentions () {
      return this.selectedExtentions.length > 0 && !this.selectAllExtentions
    },
    icon () {
      if (this.selectAllExtentions) return 'mdi-close-box'
      if (this.selectSomeExtentions) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },

    currentMonth(){
      return Number(moment().format("M"));
    },

    months(){
      let months = [
        { id: 1, name: "Januari", disabled: false },
        { id: 2, name: "Februari", disabled: false },
        { id: 3, name: "Maart", disabled: false },
        { id: 4, name: "April", disabled: false },
        { id: 5, name: "Mei", disabled: false },
        { id: 6, name: "Juni", disabled: false },
        { id: 7, name: "Juli", disabled: false },
        { id: 8, name: "Augustus", disabled: false },
        { id: 9, name: "September", disabled: false },
        { id: 10, name: "Oktober", disabled: false },
        { id: 11, name: "November", disabled: false },
        { id: 12, name: "December", disabled: false },  
      ];
      if(this.selectedPeriodYear == Number(moment().format("YYYY"))){
        months.forEach(month=>{
          if(month.id > Number(this.currentMonth)){
            month.disabled = true
          } 
          else if(this.activeCompData.created && (this.selectedPeriodYear == Number(moment.unix(this.activeCompData.created.seconds).format("YYYY")))){
            if(month.id < Number(moment.unix(this.activeCompData.created.seconds).format("M"))){
              month.disabled = true
            }
          } 
        })
        return months
      }
      else if(this.selectedPeriodYear == this.compStartYear){
        months.forEach(month=>{
          if(month.id < this.compStartMonth){
            month.disabled = true
          } 
        })
        return months
      } else{
        return months
      }
    },

    activeYears(){
      let currentYear = Number(moment().year());
      let today = moment().format("YYYY-MM-DD")
      let startDateCompany = moment.unix(this.activeCompData.created.seconds).format("YYYY-MM-DD");
      let startDateCompanyYear =  Number(moment.unix(this.activeCompData.created.seconds).format("YYYY"));
      let startYear = currentYear;

      if(currentYear > startDateCompanyYear){
        startYear = startDateCompanyYear;
      }

      let numberOfYears = Math.ceil(moment(today).diff(moment(startDateCompany), 'years', true)) + 1;
      let activeYears = Array.apply(null, Array(numberOfYears))
      let counter = 0

      activeYears.forEach((year, index)=>{
        activeYears[index] = currentYear - counter
        counter++
      })
      return activeYears
    },

    todaySelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterToday && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterToday){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    weekSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterWeek && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterWeek){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },

    monthSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterMonth && this.dataLoading){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterMonth){
        data.color = this.companyPrimaryColor;
        data.textColor = "#fff";
      } 
      return data
    },
    
    periodSelected(){
      let data = {
        color: this.$vuetify.theme.themes[this.theme].menuborder,
        textColor: this.$vuetify.theme.themes[this.theme].text,
        loading: false
      }
      if(this.filterPeriod && this.dataLoading){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
        data.loading = true
      } else if(this.filterPeriod){
        data.color = this.companyPrimaryColor
        data.textColor = "#fff";
      } 
      return data
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    userId() {
      return this.$store.state.userId;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyPrimaryColorRGBA() {
      return this.$store.state.companyPrimaryColorRGBA;
    },
    companySecondaryColorRGBA() {
      return this.$store.state.companySecondaryColorRGBA;
    },
    demoMode(){
      return this.$store.state.demoMode;
    },

    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    filteredCompanies(){
      return this.companies.filter(company => {
        return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
      });
    },

    randomMedical(){
      if(this.noDataLogs){
        let randomNumber = Math.floor(Math.random() * 7) + 1;
        let medicalClass = "medical-" + randomNumber
         return medicalClass
      } else {
        return null
      }    
    },

    filterButtonDisabled(){
      if((this.selectedPeriodYear == moment().year() && this.currentMonth < this.selectedPeriodMonth) || this.selectedPeriodYear == this.compStartYear && this.selectedPeriodMonth < this.compStartMonth){
        return true
      } else {
        return false
      }
    },
  }
};
</script>

<style lang="scss">
@import '~vue-workflow-chart/dist/vue-workflow-chart.css';
</style>

<style>
.flow-chart-wrapper{
  position: relative;
}
.workflow-chart:after,
.flow-chart-wrapper:after{
  clear: both;
  display: block;
  content: "";
}

.no-data{
  width: 280px;
  margin: 0px auto;
  padding: 80px 0;
}

.medical-image{
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.no-data p{
  font-weight: 600;
  text-align: center;
  font-size: 16px;
}

.medical-1{
  background: url('../assets/medical/medical-1.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-2{
  background: url('../assets/medical/medical-2.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-3{
  background: url('../assets/medical/medical-3.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-4{
  background: url('../assets/medical/medical-4.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-5{
  background: url('../assets/medical/medical-5.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-6{
  background: url('../assets/medical/medical-6.png') no-repeat center center;
  background-size: 180px auto;
}
.medical-7{
  background: url('../assets/medical/medical-7.png') no-repeat center center;
  background-size: 180px auto;
}

/*
<div class="unanswered-days-wrapper">
    <div class="unanswered-days">
      <div class="unanswered-label"> Zondag: </div>
      <div class="unanswered-data-wrapper" v-if="queue.week[5].number">
        <div class="unanswered-data" :style="{width : ((queue.week[5].unanswered / queue.week[5].number)*100).toFixed(0) +'%'}">
        
        </div>
        <div class="unanswered-data-number">
          {{ ((queue.week[5].unanswered / queue.week[5].number)*100).toFixed(0) }}%
        </div>

      </div>
      <div v-else class="unanswered-data-wrapper empty">-</div>

    </div>
  </div>

 */

.unanswered-hours-wrapper{
  margin: 5px 0 0 0;
  padding: 3px;
  background-color: var(--v-background-base);
}

.unanswered-days-wrapper{
  width: 100%;
  padding: 3px 0;
}

.unanswered-hour{
  margin: 2px 0;
}


.unanswered-hour:after,
.unanswered-days:after,
.unanswered-hours-wrapper:after,
.unanswered-days-wrapper:after{
  content: "";
  display: block;
  clear: both;
 }

.unanswered-label{
  width: 95px;
  float: left;
  font-weight: 600;
  font-size: 15px;
  overflow: hidden;
 }

.unanswered-label.hours{
  width: 92px;
  font-weight: 500;
  font-size: 13px;
}

.unanswered-number{
  width: 35px;
  float: left;
  height: 22px;
  line-height: 22px;
  font-weight: 400;
  font-size: 11px;
  overflow: hidden;
 }

.unanswered-data-wrapper{
  width: calc(100% - 170px);
  float: left;
  position:relative;
  height: 22px;
  background-color: var(--v-background-base);
 }

.unanswered-data-wrapper.hours{
  width: calc(100% - 167px);
  height: 18px;
  background-color: var(--v-menu-base);
}

.expand-hours{
  float: left;
  width: 30px;
  height: 21px;
}

.unanswered-data-wrapper.empty{
  background: none!important;
}

.unanswered-data-number{
  top: 0;
  height: 22px;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  position: absolute;
  line-height: 22px;
  text-align: center;
}
.unanswered-data-number.medium{
  color: #d3e1e8;
}

.unanswered-data-number.large{
  color: #ffffff;
}


.unanswered-data-number.hours{
  height: 18px;
  font-size: 12px;
  line-height: 18px;
}

.unanswered-data{
  position:relative;
  height: 22px;
  background: #2580c3;
}

.unanswered-data.hours{
  height: 18px;
}

.extention-name{
  font-weight: 600;
  padding: 0 0 0 3px;
}

.v-list-item--disabled{
  opacity: 0.3;
  cursor: not-allowed;
}

.v-list-item--disabled:hover{
  cursor: not-allowed!important;
}

.traffic-light-chart-wrapper{
  width: 100%;
  padding: 20px;
  position: relative
}

.traffic-light-chart{
  width: 100%;
  position: relative
}
.traffic-light-chart:after{
  display: block;
  clear: both;
  content: ""
}

.traffic-light{
  float: left;
  height: 36px;
  position: relative
}

.traffic-light-chart.one .traffic-light.one{
  background-color: #e85a5c!important;
  box-shadow: 0 0 10px rgba(232,90,92,0.5);
}

.traffic-light.one{
  background-color: #f7d5d6;
  width: 50%
}

.traffic-light.one:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 34px;
  padding: 0 0 0 3px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-left: 2px solid #4b4b4b;
  display: block;
  content: "0%";
}

.traffic-light-chart.dark .traffic-light.one:before,
.traffic-light-chart.dark .traffic-light.two:before,
.traffic-light-chart.dark .traffic-light.three:before,
.traffic-light-chart.dark .traffic-light.three:after{
  border-color: #f9f9f9!important;
}

.traffic-light-chart.two .traffic-light.two{
  background-color: #ffb200!important;
  box-shadow: 0 0 10px rgba(255, 178, 0,0.5);
}

.traffic-light.two{
  background-color: #feecbf;
  width:25%
}

.traffic-light.two:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 0 0 -34px;
  width: 34px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "95%";
}

.traffic-light-chart.three .traffic-light.three{
  background-color: #25cf70!important;
  box-shadow: 0 0 10px rgba(37, 207, 112,0.5);
}

.traffic-light.three{
  background-color:#ccf4da;
  width: 25%
}

.traffic-light.three:after{
  position: absolute;
  top: 0;
  right: 0;
  margin:  0;
  width: 42px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "100%";
}
.traffic-light.three:before{
  position: absolute;
  top: 0;
  left: 0;
  margin: 0px 0 0px -34px;
  width: 34px;
  height: 60px;
  line-height: 105px;
  font-size: 14px;
  border-right: 2px solid #4b4b4b;
  display: block;
  content: "98%";
}

.traffic-light.status{
  position: absolute;
  height: 16px;
  top: 10px;
  left: 0;
  background-color: #4b4b4b;
}

.traffic-light-chart.dark .traffic-light.status{
  background-color: #f9f9f9;
}

.vue-workflow-chart-state{
  font-family: "Sofia Pro", sans-serif;
  color: white;
  background: #2580c3;
}

.vue-workflow-chart-state-landline {
    color: white;
    background: #2580c3;
}

.vue-workflow-chart-state-terminated {
    color: white;
    background: #cf1e1e;
}





</style>
